var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CardContainer", {
        attrs: {
          title: _vm.education.title,
          subtitle: _vm.education.institution,
        },
        on: { update: _vm.showModal, remove: _vm.removeEducation },
        scopedSlots: _vm._u(
          [
            !_vm.isModalOpen
              ? {
                  key: "content",
                  fn: function () {
                    return [
                      _c("CardItem", {
                        attrs: { title: "Start Date", content: _vm.startDate },
                      }),
                      _c("CardItem", {
                        attrs: { title: "End Date", content: _vm.endDate },
                      }),
                      _c("CardItem", {
                        attrs: {
                          title: "Summary",
                          content: _vm.education.summary,
                          fullwidth: "",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _vm.isModalOpen
        ? _c("EducationForm", {
            attrs: {
              userId: _vm.userId,
              education: _vm.education,
              currentUserId: _vm.currentUserId,
            },
            on: {
              updated: function ($event) {
                return _vm.$emit("updated")
              },
            },
            model: {
              value: _vm.isModalOpen,
              callback: function ($$v) {
                _vm.isModalOpen = $$v
              },
              expression: "isModalOpen",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }